import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { provideNativeDateAdapter, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

registerLocaleData(localeEs);
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationService } from '../../../../shared/services/notification.service';
import { LoaderService } from '../../../../shared/services/loader.service';
import { RegisterService } from '../../services/register.service';
import { RegisterRequest } from '../../models/register-request.model';

@Component({
  selector: 'app-form-register-banamex',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatRadioModule
  ],
  providers: [
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' }
  ],
  templateUrl: './form-register-banamex.component.html',
  styleUrl: './form-register-banamex.component.scss'
})
export class FormRegisterBanamexComponent implements OnInit {
  
  registerForm!: FormGroup;
  
  private readonly TENANT_ID = 'adff7f6a-e97d-11eb-9a03-0242ac130003';
  private readonly APP_NAME = 'PortalAsistencia';
  
  productos: { value: number; viewValue: string }[] = [];

  ladaList = [
    { name: '+52', img: 'assets/flags/mx.svg' },
    { name: '+1', img: 'https://flagcdn.com/w40/us.png' }
  ];

  selectedLada: any;
  showValidationMessage = false;
  hidePassword = true;
  hideConfirmPassword = true;
  uuidClient: number = 0;
  banamexData: any;
  maxBirthDate!: Date;

  constructor(
    private fb: FormBuilder, 
    private router: Router,
    private route: ActivatedRoute,
    private registerService: RegisterService,
    private loader: LoaderService,
    private notificationService: NotificationService,
    private cd: ChangeDetectorRef,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.dateAdapter.setLocale('es-ES');
  }

  ngOnInit(): void {
    this.selectedLada = this.ladaList[0];
    
    // Calcular fecha máxima (18 años atrás desde hoy)
    this.maxBirthDate = new Date();
    this.maxBirthDate.setFullYear(this.maxBirthDate.getFullYear() - 18);
    
    this.registerForm = this.fb.group({
      nombre: ['', Validators.required],
      poliza: [''],
      correo: ['', Validators.email],
      fechaNacimiento: ['', [Validators.required, this.ageValidator]],
      producto: ['', Validators.required],
      fechaInicio: ['', Validators.required],
      fechaFin: [''],
      telefono: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      password: ['', [Validators.required, this.passwordValidator]],
      confirmPassword: ['', Validators.required],
      metodoContacto: ['', Validators.required]
    }, { validators: [this.passwordsMatch, this.dateRangeValidator] });

    // Escuchar cambios en fecha de inicio para calcular fecha fin
    this.registerForm.get('fechaInicio')?.valueChanges.subscribe(startDate => {
      if (startDate) {
        const endDate = new Date(startDate);
        endDate.setFullYear(endDate.getFullYear() + 1);
        endDate.setDate(endDate.getDate() - 1);
        this.registerForm.get('fechaFin')?.setValue(endDate);
      }
    });

    // Cargar productos y datos de Banamex
    this.loadProducts();
    this.loadBanamexData();
  }

  onSubmit(): void {
    // Debug de validación de contraseña
    const password = this.registerForm.get('password')?.value;
    console.log('Password validation:', {
      password: password,
      length: password?.length,
      hasMinLength: this.hasMinLength(),
      hasNumber: this.hasNumber(),
      hasUppercase: this.hasUppercase(),
      hasSpecialChar: this.hasSpecialChar(),
      formValid: this.registerForm.valid
    });
    
    if (this.registerForm.valid) {
      this.loader.show();
      
      const formData = this.registerForm.value;
      const today = new Date().toISOString().slice(0, 10) + ' 00:00:00';
      
      // Formatear fechas
      const formatDate = (date: Date): string => {
        return date.toISOString().slice(0, 10) + ' 00:00:00';
      };
      
      const registerPayload: RegisterRequest = {
        identifier: {
          tenants: this.TENANT_ID,
          app: this.APP_NAME
        },
        petition: {
          account: formData.producto,
          email: this.registerForm.get('correo')?.value || formData.correo,
          fullName: formData.nombre,
          memberships: this.registerForm.get('poliza')?.value || formData.poliza,
          startDate: formatDate(new Date(formData.fechaInicio)),
          endDate: formatDate(new Date(formData.fechaFin)),
          birthdate: new Date(formData.fechaNacimiento).toISOString().slice(0, 10),
          additionalEmail: '',
          phone: parseInt(formData.telefono),
          additionalPhone: 0,
          contactMeans: parseInt(formData.metodoContacto),
          privancyNoticeAcceptance: 'true',
          acceptanceTermsConditions: 'true',
          password: formData.password
        }
      };

      console.log('Form Register Banamex - Payload enviado:', registerPayload);
      console.log('Form Register Banamex - Datos del formulario:', formData);
      console.log('Form Register Banamex - Datos de Banamex:', this.banamexData);

      this.registerService.userAdd(registerPayload).subscribe({
        next: (response) => {
          this.loader.hide();
          if (response.code == 200) {
            this.notificationService.showSuccess(
              'Su registro ha sido creado exitosamente. ¡Bienvenido!', 
              '¡Registro Exitoso!',
              () => this.router.navigate(['/'], { queryParams: { uuidc: this.uuidClient } })
            );
          } else if (response.code == 409) {
            this.notificationService.showError('El usuario ya existe. Por favor, inicie sesión o use un correo diferente.', 'Usuario Existente');
          } else {
            this.notificationService.showError(response.message || 'Error al crear el registro. Intente nuevamente.');
          }
        },
        error: (err) => {
          this.loader.hide();
          if (err.error?.code == 409) {
            this.notificationService.showError('El usuario ya existe. Por favor, inicie sesión o use un correo diferente.', 'Usuario Existente');
          } else {
            this.notificationService.showError('Error al procesar el registro. Verifique su conexión e intente nuevamente.');
          }
        }
      });
    } else {
      this.markAllFieldsAsTouched();
      const requiredFields = ['nombre', 'poliza', 'correo', 'fechaNacimiento', 'producto', 'fechaInicio', 'fechaFin', 'telefono', 'password', 'confirmPassword', 'metodoContacto'];
      const hasRequiredFieldsEmpty = requiredFields.some(field => 
        !this.registerForm.get(field)?.value
      );
      
      if (hasRequiredFieldsEmpty) {
        this.showValidationMessage = true;
      }
    }
  }

  loadProducts(): void {
    this.registerService.getProducts().subscribe({
      next: (response) => {
        if (response.success && response.data) {
          this.productos = response.data.map(product => ({
            value: parseInt(product.product),
            viewValue: product.name
          }));
        }
      },
      error: (err) => {
        console.error('Error loading products:', err);
      }
    });
  }

  loadBanamexData(): void {
    this.route.queryParams.subscribe(params => {
      this.uuidClient = parseInt(params['uuidc']) || 0;
      
      const correo = params['correo'] || '';
      const poliza = params['poliza'] || '';
      
      if (correo) {
        this.registerForm.patchValue({
          correo: correo,
          poliza: poliza
        });
        this.registerForm.get('correo')?.disable();
        this.registerForm.get('poliza')?.disable();
      }
    });

    // Cargar datos adicionales del state si están disponibles
    this.banamexData = history.state?.banamexData || null;
    console.log('Datos de Banamex cargados:', this.banamexData);
    
    if (this.banamexData) {
      this.registerForm.patchValue({
        nombre: this.banamexData.name || this.banamexData.fullName || '',
        correo: this.banamexData.email || this.registerForm.get('correo')?.value,
        poliza: this.banamexData.memberships || this.registerForm.get('poliza')?.value,
        telefono: this.banamexData.phone?.toString() || this.registerForm.get('telefono')?.value
      });
    }
  }

  passwordsMatch = (group: FormGroup): null | { mismatch: true } => {
    const passwordControl = group.get('password');
    const confirmControl = group.get('confirmPassword');

    if (!passwordControl || !confirmControl) return null;

    const password = passwordControl.value;
    const confirm = confirmControl.value;

    if (password === confirm) {
      confirmControl.setErrors(null);
      return null;
    } else {
      confirmControl.setErrors({ mismatch: true });
      return { mismatch: true };
    }
  }

  dateRangeValidator = (group: FormGroup): null | { dateRange: true } => {
    const startDate = group.get('fechaInicio')?.value;
    const endDate = group.get('fechaFin')?.value;
    const endControl = group.get('fechaFin');

    if (!startDate || !endDate || !endControl) return null;

    const start = new Date(startDate);
    const end = new Date(endDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    let hasError = false;
    const errors = endControl.errors ? { ...endControl.errors } : {};

    // Validar que fecha fin > fecha inicio
    if (end <= start) {
      errors['dateRange'] = true;
      hasError = true;
    } else {
      delete errors['dateRange'];
    }

    // Validar que fecha fin >= día actual
    if (end <= today) {
      errors['pastDate'] = true;
      hasError = true;
    } else {
      delete errors['pastDate'];
    }

    endControl.setErrors(Object.keys(errors).length ? errors : null);
    return hasError ? { dateRange: true } : null;
  }

  hasMinLength(): boolean {
    const password = this.registerForm.get('password')?.value || '';
    return password.length >= 12;
  }

  hasNumber(): boolean {
    const password = this.registerForm.get('password')?.value || '';
    return /\d/.test(password);
  }

  hasUppercase(): boolean {
    const password = this.registerForm.get('password')?.value || '';
    return /[A-Z]/.test(password);
  }

  hasSpecialChar(): boolean {
    const password = this.registerForm.get('password')?.value || '';
    return /[$!%*?&+\-_]/.test(password);
  }

  isPasswordValid(): boolean {
    return this.hasMinLength() && this.hasNumber() && this.hasUppercase() && this.hasSpecialChar();
  }

  passwordValidator = (control: any) => {
    const password = control.value || '';
    const errors: any = {};
    
    if (password.length < 12) {
      errors.minLength = true;
    }
    if (!/\d/.test(password)) {
      errors.hasNumber = true;
    }
    if (!/[A-Z]/.test(password)) {
      errors.hasUppercase = true;
    }
    if (!/[$!%*?&+\-_]/.test(password)) {
      errors.hasSpecialChar = true;
    }
    
    return Object.keys(errors).length ? errors : null;
  }

  private decodeHtmlEntities(text: string): string {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
  }

  private markAllFieldsAsTouched(): void {
    Object.keys(this.registerForm.controls).forEach(key => {
      this.registerForm.get(key)?.markAsTouched();
    });
  }

  onKeyPress(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  onPhoneInput(event: any): void {
    const value = event.target.value;
    const numericValue = value.replace(/[^0-9]/g, '');
    if (value !== numericValue) {
      this.registerForm.get('telefono')?.setValue(numericValue);
    }
  }

  ageValidator = (control: any) => {
    if (!control.value) return null;
    
    const birthDate = new Date(control.value);
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      return age - 1 >= 18 ? null : { underAge: true };
    }
    
    return age >= 18 ? null : { underAge: true };
  }
}